/* src/app/common/components/image-viewer/image-viewer.component.scss */
:host {
  position: fixed;
  inset: 0;
  z-index: 10050001 !important;
  pointer-events: none;
}
#imageViewer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 300ms;
}
#imageViewer .gclose.gbtn {
  pointer-events: auto;
}
#imageViewer .panel {
  pointer-events: auto;
  position: absolute;
  width: 30%;
  right: 0;
  top: 0;
  background: #FDFDFD;
  padding: 0.5rem 1.5rem 0.25rem 1.5rem;
  height: calc(100% - 1rem);
  border-left: 0.0625rem solid #CCCCCC;
  box-shadow: 0 -6rem 1rem 0.0625rem rgba(0, 0, 0, 0.3);
}
#imageViewer .panel .panel-header {
  padding-bottom: 0.25rem;
}
#imageViewer .panel .panel-header span {
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
}
#imageViewer .panel .panel-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #EBEBEB;
}
#imageViewer .panel .panel-content {
  border: 0.0625rem solid #E7EAFD;
  border-radius: 0.5rem;
  width: calc(100% - 2rem);
  height: auto;
  max-height: 85vh;
  padding: 1rem;
  margin-top: 1rem;
  overflow-y: scroll;
}
#imageViewer .panel .panel-content h5 {
  font-family: "PoppinsBlack";
  color: #1E31BF;
  margin-bottom: 0.5rem;
}
#imageViewer .panel .panel-content .context {
  font-family: "PoppinsSemi Bold";
  font-size: 0.875rem;
  line-height: 130%;
}
#imageViewer .panel .panel-content .reference {
  margin-bottom: 0.75rem;
  font-family: "PoppinsSemi Bold";
  font-size: 12px;
  border: 1px solid #E7EAFD;
  border-radius: 15px;
  padding: 1rem;
  -webkit-transition: all 300ms ease-in-out;
  -moz-transition: all 300ms ease-in-out;
  -ms-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  box-shadow: 0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.03), 0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.05);
}
#imageViewer .panel .panel-content .reference:hover {
  cursor: pointer;
  background: rgba(30, 49, 191, 0.07);
}
#imageViewer .panel .panel-content .reference .reference-header {
  margin-bottom: 1rem;
}
#imageViewer .panel .panel-content .reference .reference-header span {
  color: #1E31BF;
  font-size: 1rem;
}
#imageViewer .panel .panel-content .reference .reference-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#imageViewer .panel .panel-content .reference .reference-header .annotations-count {
  background: #1E31BF;
  color: white;
  border-radius: 50%;
  font-size: 0.75rem;
  font-family: "PoppinsBold";
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
#imageViewer .image-buttons-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
}
#imageViewer .image-buttons-wrapper .buttons-wrapper {
  pointer-events: auto;
  position: absolute;
  display: inline-flex;
}
#imageViewer .image-wrap {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep .px-popover.image-viewer-context-hint {
  min-width: 10rem;
}
/*# sourceMappingURL=image-viewer.component.css.map */
